import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';
import { CrewQuestionnaireKind, useCrewQuestionnaireKind } from './useData';

const Detail: React.FC = () => <GenericDetailPage<CrewQuestionnaireKind> useData={useCrewQuestionnaireKind} config={{ ...moduleConfig, getDetailSections, getStatusBadges }} />;
export default Detail;
